export default {
    printCustomResults({ disp }, payload) {
        MulticalculoResidencial.printResults(payload.quotationId, payload.token);
    }
}


// WEBPACK FOOTER //
// ./src/residential/modules/Result/vuex/actions.js